import { extractFileNameFromWindowsPath } from '../../../../shared/utils/utils-string-manipulation';
import isFunction from 'lodash/isFunction';
import axios from 'axios';
import { http } from '../../../axios';
import { localContentPrefix } from '../../../../config';
import { UploadProgressCallback } from './useUploadLocalContentAsset';

export const uploadLocalProductAsset = (
    asset: File,
    assetType: string,
    id: string,
    uploadProgressCallback: UploadProgressCallback,
    url: string
) => {
    const newFileName = extractFileNameFromWindowsPath(asset.name);
    const data = new FormData();

    data.append(assetType, asset, newFileName);

    const params = {
        pathParams: { id }
    };

    if (isFunction(uploadProgressCallback)) {
        params['onUploadProgress'] = progressEvent => {
            const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            uploadProgressCallback(percentCompleted);
        };
    }

    return http
        .post(url, data, params)
        .then(response => {
            return response.data;
        })
        .catch(response => {
            if (!axios.isCancel(response)) {
                return;
            } else {
                return Promise.reject({ cancelled: true });
            }
        });
};

const urlCovers = `${localContentPrefix}/v1/localcontent/products/cover/:id`;
const urlAssets = `${localContentPrefix}/v1/localcontent/products/asset/:id`;
export const uploadCover = (asset: File, id: string, uploadProgressCallback: UploadProgressCallback) => {
    return uploadLocalProductAsset(asset, 'cover', id, uploadProgressCallback, urlCovers);
};

export const uploadPdf = (asset: File, id: string, uploadProgressCallback: UploadProgressCallback) => {
    return uploadLocalProductAsset(asset, 'asset', id, uploadProgressCallback, urlAssets);
};
